/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupJobType } from '../models/BackupJobType';
import { Pagination } from '../models/Pagination';

export class ListBackupJobTypesResponse {
  'backupJobTypes': Array<BackupJobType>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "backupJobTypes",
      "baseName": "backupJobTypes",
      "type": "Array<BackupJobType>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListBackupJobTypesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

